export const phaseStatus = {
	EM_ANDAMENTO: 1,
	INSUCESSO: 2,
	SUCESSO: 3,
	NEGOCIOS_FUTUROS: 4,
}
